import { useEffect, useState } from 'react';
import { useUserNotificationsQuery } from '@/graphql';
import type { NotificationType } from '@/graphql';
import { NotifTypes } from '@/type';
import { useAuth } from '@/contexts/auth-context';

interface ParsedNotification extends NotificationType {
  parsedData: {
    type: NotifTypes;
  };
}

const useNotifications = () => {
  const { token } = useAuth();

  const { data: notificationsData } = useUserNotificationsQuery({
    skip: !token,
  });

  const [notifications, setNotifications] = useState<ParsedNotification[]>([]);

  useEffect(() => {
    if (!notificationsData) return;

    const unreadNotifications = notificationsData.notifications?.filter(
      (notification) => !notification?.isRead
    );

    const parsedNotifications = unreadNotifications
      ?.map((notification) => {
        try {
          const parsedData = JSON.parse(notification?.data);
          return { ...notification, parsedData };
        } catch (error) {
          console.error('Error parsing notification data:', error);
          return null;
        }
      })
      .filter((notification): notification is ParsedNotification => notification !== null);

    if (parsedNotifications) setNotifications(parsedNotifications);
  }, [notificationsData]);

  return {
    notifications,
  };
};

export default useNotifications;
